module.exports = __webpack_public_path__ + "img/logo.bf60ace2.png";